import { Modal } from "react-bootstrap";
import * as Comp from "../../../common/CommonComponents";
import * as common from "../../../common/common";
import http from "../../../common/http-common";
import { useState, useRef, useEffect } from "react";
import { toast } from "react-toastify";
import { useCookies } from "react-cookie";

import RejectTicket from "./RejectTicket";
import DownloadIcon from '@mui/icons-material/Download';
import close from "../../../assets/close-icon.png";
import view from "../../../assets/view-icon.png";
import verify from "../../../assets/verify-icon.png";
import reject from "../../../assets/reject-icon.png";
import save from "../../../assets/save-icon.png";

const PAGE_NAME = "VerifyTicket.js_";

const VerifyTicket = (props) => {
  const { buttonAuthority } = props;
  //console.log("Button Authority:", buttonAuthority);
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);
  const [inputError, setInputError] = useState([]);
  const remarkInputRef = useRef();
  const [showConfirm, setShowConfirm] = useState(false);
  const [showReject, setShowReject] = useState(false);
  const [verifyData, setVerifyData] = useState({
    ROOT_CAUSE: "",
    SOLUTION: "",
    REMARK: "",
    REJECT_REASON: "",
  });

  //MODIFY FILES
  const [deletedFileIds, setDeletedFileIds] = useState([]);
  //const [newFiles, setNewFiles] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const [fileColumns, setFileColumns] = useState([]);
  const [columns, setColumns] = useState([]);
  //var emptyFile = { name: " ", size: " " }
  const [viewData, setViewData] = useState([]);
  const [rejectData, setRejectData] = useState([]);
  const [fileData, setFileData] = useState([]);
  const [verifyConfirmData, setVerifyConfirmData] = useState([]);
  const message = (
    <>
      Confirm to Verify?
      <br />
      Ticket Num:
      {<b>{props.viewData !== null && props.viewData.TICKET_NUM}</b>}
    </>
  );

  const SendEmail = (_data) => { 
    let functionName = "onSaveConfirmHandler";

    try {
        props.onLoading(true, "Sending email, please wait...");
        const data = {
            TICKET_MST_ID: _data.TICKET_MST_ID,
            TICKET_NUM: _data.TICKET_NUM, 
            ORG_ID: _data.ORG_ID,   
            ORG_NAME: _data.ORG_NAME,
            SYSTEM_MST_ID: _data.SYSTEM_MST_ID,
            SYSTEM_MST_NAME: _data.SYSTEM_MST_NAME,
            UPDATE_ID: userId,
        };
        http
            .post("api/Ticket/SendVerifyEmail", data, { timeout: common.DEFAULT_TIMEOUT })
            .then((response) => {
              props.onLoading(true, "Sending email...");
            })
            .catch((err) => {    
                common.c_LogWebError(props.page, functionName, err);
            })
            .finally(() => {
                props.onLoading(false, "Loading...");
            })


    } catch (err) {
        props.onLoading(false, "Loading...");
        toast.error("Failed to send");
        common.c_LogWebError(props.page, functionName, err);
    }
  };

  const VerifyBtnOnClick = () => {
    VerifyTicket(props.viewData);
  }

  const showDetails = (e, row) => {
    setViewData(row);
    setFileData(row.FILE_DETAILS);
  }


  const showRejectModal = (e, row) => {
    
    setShowReject(true);
    props.onHide();
    setRejectData(row);
  }

  function VerifyTicket(_data) {
    let functionName = "";
    try {
      functionName = "Verify Ticket";

      props.onLoading(true, "Verifying ticket, please wait...");

      const data = {
        TICKET_MST_ID: _data.TICKET_MST_ID,
        TICKET_NUM: _data.TICKET_NUM,
        TICKET_VERIFY_ID: verifyConfirmData.TICKET_VERIFY_ID,
        TICKET_STATUS_TYPE_ID: _data.TICKET_STATUS_TYPE_ID,
        TICKET_STATUS_TYPE_NAME: _data.TICKET_STATUS_TYPE_NAME,
        UPDATE_ID: userId,
        UPDATE_DATETIME: _data.UPDATE_DATETIME,
      };

      http
        .post("api/ticket/VerifyTicket", data, { timeout: 10000 })
        .then((response) => {
          if (response.data.OPEN_STATUS === false) {
            if (response.data.TICKET_STATUS_TYPE_NAME === "CLOSED") {
              toast.error("Ticket " + response.data.TICKET_NUM + " has been " + response.data.TICKET_STATUS_TYPE_NAME.toLowerCase() + '.');   
            } else if (response.data.TICKET_STATUS_TYPE_NAME === "CANCEL") {
              toast.error("Ticket " + response.data.TICKET_NUM + " has been " + response.data.TICKET_STATUS_TYPE_NAME.toLowerCase() + 'led.');   
            } else if (response.data.TICKET_STATUS_TYPE_NAME === "Verify") {
              toast.error("Ticket " + response.data.TICKET_NUM + " has been verified." );   
            }                
            props.onReload();
            hideModal();
          }
          else {
            toast.success("Ticket is successfully verified.");
            SendEmail(_data);
            props.onReload();
            hideModal();
            setShowConfirm(!showConfirm);
          }     
        })
        .catch((err) => {
          toast.error("Failed to verify ticket. Please try again.");
          common.c_LogWebError(props.page, functionName, err);
          props.onShow();
        })
        .finally(() => {
          props.onLoading(false, "Loading...");
        });
    } catch (err) {
        props.onLoading(false, "Loading...");
        toast.error("Failed to verify ticket. Please try again.");
        common.c_LogWebError(props.page, functionName, err);
        props.onShow();
    }
  }
  
  const hideModal = () => {
    setViewData([]);
    setFileData([]);
    props.onHide();
  };
  
    
  const hideConfirmModal = () => {
    setShowConfirm(!showConfirm);
    props.onShow();
  };
  
  const showConfirmModal = (e, row) => {
    props.onHide();
    setVerifyConfirmData({
      TICEKT_MST_ID: row.TICEKT_MST_ID,
      TICKET_NUM: verifyData.TICKET_NUM,
      TICKET_VERIFY_ID: row.TICKET_VERIFY_ID,
    })
    setShowConfirm(true);
  }
  const hideRejectModal = () => {
    setShowReject(!showReject);
  };
  
  const normalizeNullable = (value) => {
  return (value === undefined || value === null || value.trim().toLowerCase() === "null" || value.trim() === "") 
    ? "" 
    : value;
};

  //UPDATE VERIFY DATA
  const onClickUpdate = () => {
  props.onLoading(true, "Saving verify data...");

  const formData = new FormData();
  formData.append("TICKET_VERIFY_ID", viewData.TICKET_VERIFY_ID);
  formData.append("SOLUTION", normalizeNullable(viewData.SOLUTION));
  formData.append("REMARK", normalizeNullable(viewData.REMARK));
  formData.append("REJECT_REASON", normalizeNullable(viewData.REJECT_REASON));
  formData.append("UPDATE_ID", userId);
  formData.append("DELETED_FILE_IDS", deletedFileIds.join(','));

  // Append files
  selectedFiles.forEach((file, index) => {
  formData.append(`file${index}`, file);
  });

  http.post("api/ticket/UpdateVerifyTicketWithFiles", formData, {
    timeout: 30000,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
  .then(res => {
  toast.success('Updated successfully.');
  
  setFileData(prev => [
    ...prev,
    ...selectedFiles.map(file => ({
      FILE_NAME: file.name,
      FILE_TYPE: 'RESOLVE',
      IS_NEW: true,
    })),
  ]);
  setSelectedFiles([]);   // Clear selected files after upload
  setDeletedFileIds([]);
  props.onReload();
  hideModal();
})

  .catch(err => {
    toast.error('Error updating verify ticket.');
    common.c_LogWebError(PAGE_NAME, "onClickUpdate", err);
  })
  .finally(() => {
    props.onLoading(false, "Loading...");
  });
};


    //DELETE FILE
    const handleDeleteFile = (file) => {
    // If the file has an ID, it's from the database
      if (file.TICKET_VERIFY_FILE_ID) {
        setDeletedFileIds((prev) => [...prev, file.TICKET_VERIFY_FILE_ID]);
        setFileData((prev) =>
          prev.filter((f) => f.TICKET_VERIFY_FILE_ID !== file.TICKET_VERIFY_FILE_ID)
        );
      } else {
        // Newly added file (not uploaded yet)
        setSelectedFiles((prev) =>
          prev.filter((f) => f.name !== file.FILE_NAME)
        );
      }
    };

    // const mergedFiles = [
    //   ...fileData, 
    //   ...newFiles.map((file, idx) => ({
    //     TICKET_VERIFY_FILE_ID: null,
    //     FILE_NAME: file.name,
    //     IS_NEW: true,
    //     FILE_OBJECT: file,
    //   }))
    // ];

  useEffect(() => {
    setFileColumns([
        {
            accessorFn: (row) => row.FILE_NAME,
            header: "Filename",
            size: "60",
        },
        {
          accessorFn: (row) => row.FILE_TYPE,
          header: "Type",
          size: "10",
        },
        {
            id: "Action",
            header: "Action",
            size: "10",
            accessorFn: (row) => (
                <div>
                     <span>
                        <Comp.Button
                          id="btnDownload"
                          type="general"
                          onClick={(e) => downloadFile(row.TICKET_VERIFY_FILE_ID)}
                        >
                          Download
                        </Comp.Button>
                        <Comp.Button
                          id="btnDeleteFile"
                          type="delete"
                          onClick={() => handleDeleteFile(row)}
                        >
                          Delete
                        </Comp.Button>
                     </span>
                </div>
            ),
        }
    ])
  }, [viewData])

  useEffect(() => {
    var functionName = "set data";
    try {
      if (props.viewData!= null && props.viewData.VERIFY_DETAIL != null &&props.viewData.VERIFY_DETAIL.length > 0) {
        setColumns([
          {
            accessorFn: (row) => row.ROOT_CAUSE,
            header: "ROOT_CAUSE",
            size: "350",

            Cell: ({ cell }) => {
              const [isExpanded, setIsExpanded] = useState(false);
              const text = cell.getValue();
              const maxLength = 77;
              // Toggle expand/collapse
              const toggleExpand = () => {
                setIsExpanded(prevState => !prevState);
              };

              return (
                <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                  {text?.length > maxLength ? (
                    <>
                      {/* Show either truncated or full text based on state */}
                      {isExpanded ? text : text.substring(0, maxLength) + "..."} 
                      &nbsp;
                      {/* Toggle button */}
                      <a 
                        onClick={toggleExpand}
                        style={{ 
                          color: '#007bff', 
                          cursor: 'pointer', 
                          textDecoration: 'none',
                          fontWeight: 'bold' 
                        }}
                        onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                        onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                        >
                          {isExpanded ? "Show less" : "Read more"}
                      </a>
                    </>
                  ) : (
                    text
                  )}
                </div>
              );
            },
          },
       
          {
            id: "Action",
            header: "Action",
            size: "150",
            accessorFn: (row) => (
              <div>
                <span>
                  <Comp.Button
                    id="btnView"
                    type="general"
                    onClick={(e) => showDetails(e, row)}
                  >
                    View  <img src={view} alt="View" style={{ width: "18px", height: "18px", marginLeft: "2px", marginBottom: "2px" }} />
                  </Comp.Button>
                  <Comp.Button
                    id="btnVerified"
                    type="verify"
                    hidden={row.STATUS != "RESOLVED" || props.buttonAuthority.VERIFY != "Y" ? true : false}
                    onClick={(e) => showConfirmModal(e, row)}
                  >
                    Verify  <img src={verify} alt="Verify" style={{ width: "18px", height: "18px", marginLeft: "2px", marginBottom: "2px" }} />
                  </Comp.Button>
                  <Comp.Button
                    id="btnReject"
                    type="delete"
                    hidden={row.STATUS != "RESOLVED" || props.buttonAuthority.VERIFY != "Y" ? true : false}
                    onClick={(e) => showRejectModal(e, row)}
                  >
                    Reject  <img src={reject} alt="Reject" style={{ width: "18px", height: "18px", marginLeft: "2px", marginBottom: "2px" }} />
                  </Comp.Button>
                </span>
              </div>
            ),
          }
        ]);
        setVerifyData(props.viewData.VERIFY_DETAIL);
      }
      else {
        var value = verifyData;
      }
    }
      catch (err) {
        //props.onLoading(false, "Loading...");
        toast.error("Failed to verify ticket. Please try again.");
        common.c_LogWebError(props.page, functionName, err);
    
    }
  }, [props.viewData])


  function downloadFile(verifyFileId) {
      window.open(
        common.c_getApiUrl() +
        `api/ticket/ExportVerifyFile?_user=${userId}&_verifyFileId=${verifyFileId}`,
        { timeout: 100000 }
      );
    
}

const formatSize = (bytes) => {
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes === 0) return "0 Byte";
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
};

  return (
    <> <Modal show={props.showHide} onHide={props.onHide} centered size='lg'>
    <Modal.Header>
      <div style={{ backgroundColor: "lightgrey", width: "100%", textAlign: "center" }}>
        <Modal.Title>Verify Ticket</Modal.Title>
      </div>
    </Modal.Header>
    <Modal.Body>
      <label>Rootcause :</label>
      <Comp.Table data={verifyData} columns={columns}  enableTopToolbar={false}/> 
        <div style={{ display: viewData.length == 0 ?'none' : 'block' }}>
        <Comp.TextArea
            ref={remarkInputRef}
            id="SOLUTION"
            type="text"
            name= "Solutions"
            className="form-control"
            value={viewData.SOLUTION}
            label = "Solutions :"
            //readOnly={true}
            onChange={(e) => setViewData({ ...viewData, SOLUTION: e.target.value })}
          />     
  
          <Comp.TextArea
            ref={remarkInputRef}
            id="REMARK"
            name= "Remark"
            type="text"
            className="form-control"
            value={viewData.REMARK}
            label = "Remark :"
            //readOnly={true}
            onChange={(e) => setViewData({ ...viewData, REMARK: e.target.value })}
          />
          <Comp.TextArea
            ref={remarkInputRef}
            id="REJECT_REASON"
            type="text"
            name= "Reject Reason"
            className="form-control"
            value={viewData.REJECT_REASON}
            label="Reject Reason :"
            hidden={viewData.STATUS != "REJECTED"}
            //readOnly={true}
            onChange={(e) => setViewData({ ...viewData, REJECT_REASON: e.target.value })}
          />     
          <br></br>
         <label>Uploaded Files :</label>
        <Comp.Table data={fileData} columns={fileColumns} />
            {buttonAuthority.UPDATE_VERIFY_DETAIL === "Y" && (
              <>
                <label className="mt-2 block">Attach new files:</label>
                <input
                  type="file"
                  multiple
                  onChange={(e) => setSelectedFiles(Array.from(e.target.files))}
                />
              </>
      )}
        </div>  
    </Modal.Body>
    <Modal.Footer>
      <div style={{ textAlign: "center", width: "100%" }}>
        <Comp.Button
          id="btnUpdate"
          type="delete"
          onClick={onClickUpdate}
          hidden={buttonAuthority.UPDATE_VERIFY_DETAIL !== "Y"} // check authority
        >
          Update <img src={save} alt="Save" style={{ width: "20px", height: "20px", marginLeft: "2px", marginBottom: "2px" }} />
        </Comp.Button>
        <Comp.Button id="btnClose" type="general" onClick={hideModal}>
        Close  <img src={close} alt="Close" style={{ width: "20px", height: "20px", marginLeft: "2px", marginBottom: "2px" }} />
      </Comp.Button>
      </div>
    </Modal.Footer>
  </Modal>

    <RejectTicket
        page={props.page}
        showHide={showReject}
        viewData={rejectData}
        onShow={props.onShow}
        onHide={hideRejectModal}
        onReload={props.onReload}
        onLoading={props.onLoading}
      />
    
    <Comp.ConfirmModal
      show={showConfirm}
      onHide={hideConfirmModal}
      onConfirm={VerifyBtnOnClick}
    >
      {message}
    </Comp.ConfirmModal>
      </>
  );
}

export default VerifyTicket;